
export const colorBack = () => {
  return "#005C8A";
};

export const colorPrimary = () => {
  return "#0A78BE";
};

export const colorIconesMenu = () => {
  return "#54656F";
};

export const colorTitleTable = () => {
  return "#3B4A54";
};

export const colorTopTable = () => {
  return "#F0F2F5";
};

export const colorBackgroundTable = () => {
  return "#FFFFFF";
};

export const colorLineTable = () => {
  return "#E9EDEF";
};

export const colorLineTableHover = () => {
  return '#F5F6F6';
};

export const colorTopbar = () => {
  return "#005C8A";
};

export const shadowSmall = () => {
  return "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)";
};

export const shadowMedium = () => {
  return "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
};

export const shadowLarge = () => {
  return "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)";
};